import { render, staticRenderFns } from "./DateColumn.vue?vue&type=template&id=22b7a8a7&"
import script from "./DateColumn.vue?vue&type=script&lang=ts&"
export * from "./DateColumn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports